// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"37":"postload","160":"components"}[chunkId] + ".chunk.B194CoriginmasterD20240603203651.js";
};